import { render, staticRenderFns } from "./DocumentGuidanceView.vue?vue&type=template&id=5a286be2&scoped=true"
import script from "./DocumentGuidanceView.vue?vue&type=script&lang=js"
export * from "./DocumentGuidanceView.vue?vue&type=script&lang=js"
import style0 from "./DocumentGuidanceView.vue?vue&type=style&index=0&id=5a286be2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a286be2",
  null
  
)

export default component.exports